import { render, staticRenderFns } from "./FileDrag.vue?vue&type=template&id=7e1f5412&scoped=true"
import script from "./FileDrag.vue?vue&type=script&lang=js"
export * from "./FileDrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.14_css-loader@6.11.0_webpack@5.99.8__ejs@3.1.10_loda_tabtodhn2upniikejzvtfgbz5m/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1f5412",
  null
  
)

export default component.exports